import { gql } from "@apollo/client";

export const QUERY_GET_USER_TO_PATHOLOGIES = gql`
  query QUERY_GET_USER_TO_PATHOLOGIES($userId: uuid!) {
    userToPatology(where: { userId: { _eq: $userId } }) {
      date
      id
      typePatology
      userId
      typePatologyVal {
        name
        value
      }
    }
  }
`;

export const QUERY_GET_ALL_PATHOLOGIES_BY_PROCESS = gql`
  query QUERY_GET_ALL_PATHOLOGIES_BY_PROCESS($processIds: [Int!]!) {
    typePatology(
      where: {
        _or: [
          { processId: { _in: $processIds } }
          { processId: { _is_null: true } }
        ]
      }
    ) {
      groupPatology
      name
      value
    }
  }
`;
